import { render, staticRenderFns } from "./MinWagePicker.vue?vue&type=template&id=3e7c0f52&scoped=true&"
import script from "./MinWagePicker.vue?vue&type=script&lang=ts&"
export * from "./MinWagePicker.vue?vue&type=script&lang=ts&"
import style0 from "./MinWagePicker.vue?vue&type=style&index=0&id=3e7c0f52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7c0f52",
  null
  
)

export default component.exports